export default __webpack_public_path__ + "static/media/logo.2f6616b7.png";